// extracted by mini-css-extract-plugin
export default {"navigationContainer":"Menu_navigationContainer__u0z+H"};